export default "__VITE_ASSET__BhRSjspN__"